import {COINS} from "../constants";

const initialState = {
	coins: [],
};
// eslint-disable-next-line
export default (state = initialState, {type, payload}) => {
	switch (type) {
		case COINS:
			return {
				...state,
				coins: payload,
			};

		default:
			return state;
	}
};
